// extracted by mini-css-extract-plugin
module.exports = {"commitMessage":"style-module_commitMessage__2Zu-uJGwNTSuxVvq0GR90v"};